import { AsyncPipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
  MatHeaderRow,
  MatHeaderRowDef,
  MatRow,
  MatRowDef,
  MatTable,
} from '@angular/material/table';
import { NgxPaginationModule } from 'ngx-pagination';
import { OnlysuperuserDirective } from '../../../../shared/directives/onlysuperuser.directive';
import { PermisionDirective } from '../../../../shared/directives/permision.directive';
import { Search } from '../../../../shared/components/search/search';
import { ConsumableAsset } from '../../../../core/models/consumableasset.interface';
import { catchError, map, Observable, switchMap, tap } from 'rxjs';
import { LayoutService } from '../../../../core/services/layout/layout';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { LoadingService } from '../../../../core/services/loading/loading';
import { Title } from '@angular/platform-browser';
import { ConsumableassetService } from '../../../../core/services/consumableasset/consumableasset-service';
import { PAGINATION } from '../../../../core/constants/constants';
import { Filter, QueryGet } from '../../../../core/types/query-types';
import { ConsumableassetForm } from '../consumableasset-form/consumableasset-form';

@Component({
  selector: 'app-consumableasset-list',
  imports: [
    MatIcon,
    MatTable,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatCellDef,
    MatCell,
    MatHeaderRowDef,
    MatHeaderRow,
    MatRowDef,
    MatRow,
    NgxPaginationModule,
    AsyncPipe,
    OnlysuperuserDirective,
    PermisionDirective,
    Search,
  ],
  templateUrl: './consumableasset-list.html',
  styleUrl: './consumableasset-list.scss',
})
export class ConsumableassetList {
  public page = 1;
  total: number = 0;
  limit: number = 10;
  consumableAssets: ConsumableAsset[] = [];
  asyncConsumableAssets!: Observable<ConsumableAsset[]>;
  buscarconsumableassets: string = '';
  @Input() filtro: string = '';
  @Input() orden: string = '';
  showColumns: string[] = ['acciones', 'id', 'name', 'unity', 'value', 'package', 'description', 'term'];

  constructor(
    private layoutService: LayoutService,
    private activatedRouter: ActivatedRoute,
    private router: Router,
    private dialog: MatDialog,
    private toastr: ToastrService,
    private consumableAssetService: ConsumableassetService,
    private loadingService: LoadingService,
    private title: Title,
  ) {
    this.title.setTitle('Activos Consumibles');
  }

  ngOnInit(): void {
    this.layoutService.paginationLimit$
      .pipe(
        switchMap((limit) => {
          this.limit = limit;
          return this.activatedRouter.queryParamMap;
        }),
        switchMap((params) => {
          const pageNum = params.get('page') || '1';
          const search = params.get('search') || '';
          this.page = parseInt(pageNum);
          this.fetchConsumableassets(PAGINATION.first_page, null, search);
          return this.layoutService.paginationLimit$;
        }),
      )
      .subscribe();
  }

  fetchConsumableassets(page: number, filter: Filter | null = null, search = '') {
    const offset = page > 1 ? page * this.limit - this.limit : 0;
    const params: QueryGet = {
      order: '-id',
      limit: this.limit,
      offset,
      search,
      filters: [],
    };
    if (filter) {
      params.filters.push(filter);
    }
    this.page = page;
    this.loadingService.show(true);
    this.asyncConsumableAssets = this.consumableAssetService.getConsumableAsset(params).pipe(
      tap((data) => {
        this.consumableAssets = data.results;
        this.consumableAssetService.setConsumableAsset(data.results[0]);
        this.consumableAssetService.setConsumableAssets(data.results);
        this.total = data.count;
      }),
      map((res) => {
        this.loadingService.show(false);
        return res.results;
      }),
      catchError((error) => {
        this.loadingService.show(false);
        const errorMsg = `¡Se ha producido un error, inténtelo nuevamente!`;
        this.toastr.error(errorMsg, 'Error!', {
          progressBar: true,
          timeOut: 5000,
        });
        this.router.navigate(['home']);
        return [];
      }),
    );
  }

  createConsumableAsset() {
    this.consumableAssetService.removeConsumableAssetSelected();
    const dialogRef = this.dialog.open(ConsumableassetForm, {
      width: '600px',
      height: 'auto',
      maxHeight: '80vh',
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe(() => {
      this.fetchConsumableassets(this.page);
    });
  }

  updateConsumableAsset(consumableAsset: ConsumableAsset) {
    this.consumableAssetService.setConsumableAsset(consumableAsset);
    const dialogRef = this.dialog.open(ConsumableassetForm, {
      width: '600px',
      height: 'auto',
      maxHeight: '80vh',
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe(() => {
      this.fetchConsumableassets(this.page);
    });
  }

  eliminate(consumableAsset: ConsumableAsset): void {
    const confirmed = window.confirm(
      `¿Estás seguro de eliminar el registro: ${consumableAsset.name}?`,
    );
    if (!confirmed) return;
    this.consumableAssetService.delete(consumableAsset.id).subscribe({
      next: () => {
        const successMsg = `Eliminado CORRECTAMENTE!`;
        this.toastr.success(successMsg, 'Exitoso!', {
          progressBar: true,
          timeOut: 5000,
        });
        this.fetchConsumableassets(this.page);
      },
      error: (err) => {
        this.toastr.error('No se pudo eliminar', 'Error');
      },
    });
  }
}
